import { http } from '@/network/http';
import type {
  DashboardStats,
  EarningsHistoryItem,
  ReportTypeMeta,
  TreatmentBreakdownItem,
  WeeklyActivityItem,
  MonthlySummary,
  RecentReport,
} from './types';

function buildParams(params: Record<string, string | number | undefined>): Record<string, string | number> | undefined {
  const clean: Record<string, string | number> = {};
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined) clean[k] = v;
  }
  return Object.keys(clean).length > 0 ? clean : undefined;
}

export const dashboardApi = {
  getStats: (month?: string, status?: string, userId?: string) =>
    http.get<{ success: boolean; stats: DashboardStats }>('/dashboard/stats', {
      params: buildParams({ month, status, userId }),
    }),

  getEarningsHistory: (months?: number, status?: string, userId?: string) =>
    http.get<{ success: boolean; history: EarningsHistoryItem[]; reportTypes: ReportTypeMeta[] }>('/dashboard/earnings-history', {
      params: buildParams({ months, status, userId }),
    }),

  getTreatmentBreakdown: (month?: string, status?: string, userId?: string) =>
    http.get<{ success: boolean; breakdown: TreatmentBreakdownItem[] }>('/dashboard/treatment-breakdown', {
      params: buildParams({ month, status, userId }),
    }),

  getWeeklyActivity: (month?: string, status?: string, userId?: string) =>
    http.get<{ success: boolean; activity: WeeklyActivityItem[]; reportTypes: ReportTypeMeta[] }>('/dashboard/weekly-activity', {
      params: buildParams({ month, status, userId }),
    }),

  getMonthlySummary: (month?: string, status?: string, userId?: string) =>
    http.get<{ success: boolean; summary: MonthlySummary }>('/dashboard/monthly-summary', {
      params: buildParams({ month, status, userId }),
    }),

  getRecentReports: (limit?: number, userId?: string) =>
    http.get<{ success: boolean; reports: RecentReport[] }>('/dashboard/recent-reports', {
      params: buildParams({ limit, userId }),
    }),
};
